import { ComposePaths, ExtractRouteParams, withParams } from 'src/routing/routing-utils'
import { ApplicationTypeManagementIndexPage } from 'src/screens/administration/application-type-management/ApplicationTypeManagementIndexPage'
import { CommitteeConfigurationIndexPage } from 'src/screens/administration/configuration-management/committees-configuration/CommitteeConfigurationIndexPage'
import { CriteriaConfigurationCriteriaGroupsPage } from 'src/screens/administration/configuration-management/criteria-configuration/criteria-group/CriteriaConfigurationCriteriaGroupsPage'
import { CriteriaConfigurationCriteriaGroupsCreatePage } from 'src/screens/administration/configuration-management/criteria-configuration/criteria-group/edit/CriteriaConfigurationCriteriaGroupsCreatePage'
import { CriteriaConfigurationCriteriaGroupsEditPage } from 'src/screens/administration/configuration-management/criteria-configuration/criteria-group/edit/CriteriaConfigurationCriteriaGroupsEditPage'
import { CriteriaConfigurationIndexPage } from 'src/screens/administration/configuration-management/criteria-configuration/CriteriaConfigurationIndexPage'
import { CriteriaConfigurationEvaluationCriteriaPage } from 'src/screens/administration/configuration-management/criteria-configuration/evaluation-criteria/CriteriaConfigurationEvaluationCriteriaPage'
import { CriteriaConfigurationEvaluationCriteriaCreatePage } from 'src/screens/administration/configuration-management/criteria-configuration/evaluation-criteria/edit/CriteriaConfigurationEvaluationCriteriaCreatePage'
import { CriteriaConfigurationEvaluationCriteriaEditPage } from 'src/screens/administration/configuration-management/criteria-configuration/evaluation-criteria/edit/CriteriaConfigurationEvaluationCriteriaEditPage'
import { CriteriaConfigurationFactsheetPage } from 'src/screens/administration/configuration-management/criteria-configuration/factsheet/CriteriaConfigurationFactsheetPage'
import { CriteriaConfigurationPfKapPage } from 'src/screens/administration/configuration-management/criteria-configuration/pf-kap/CriteriaConfigurationPfKapPage'
import { CriteriaConfigurationPfPgvPage } from 'src/screens/administration/configuration-management/criteria-configuration/pf-pgv/CriteriaConfigurationPfPgvPage'
import { FeaturesConfigurationIndexPage } from 'src/screens/administration/configuration-management/features-configuration/FeaturesConfigurationIndexPage'
import { HelpInstructionsConfigCreatePage } from 'src/screens/administration/configuration-management/help-instructions-configuration/edit/HelpInstructionsConfigCreatePage'
import { HelpInstructionsConfigEditPage } from 'src/screens/administration/configuration-management/help-instructions-configuration/edit/HelpInstructionsConfigEditPage'
import { HelpInstructionsConfigurationIndexPage } from 'src/screens/administration/configuration-management/help-instructions-configuration/HelpInstructionsConfigurationIndexPage'
import { MilestoneConfigurationEditPage } from 'src/screens/administration/configuration-management/milestones-configuration/edit/MilestoneConfigurationEditPage'
import { MilestonesConfigurationIndexPage } from 'src/screens/administration/configuration-management/milestones-configuration/MilestonesConfigurationIndexPage'
import { CommitteeConfigurationPfKapPage } from 'src/screens/administration/configuration-management/committees-configuration/pf-kap/CommitteeConfigurationPfKapPage'
import { CommitteeConfigurationPfPgvPage } from 'src/screens/administration/configuration-management/committees-configuration/pf-pgv/CommitteeConfigurationPfPgvPage'
import { CommitteeConfigurationFactsheetPage } from 'src/screens/administration/configuration-management/committees-configuration/factsheet/CommitteeConfigurationFactsheetPage'
import { CommitteeConfigurationCreatePage } from 'src/screens/administration/configuration-management/committees-configuration/edit/CommitteeConfigurationCreatePage'
import { CommitteeConfigurationEditPage } from 'src/screens/administration/configuration-management/committees-configuration/edit/CommitteeConfigurationEditPage'
import { PrinciplesConfigurationPrinciplesCreatePage } from 'src/screens/administration/configuration-management/principles-configuration/principles/edit/PrinciplesConfigurationPrinciplesCreatePage'
import { PrinciplesConfigurationPrinciplesEditPage } from 'src/screens/administration/configuration-management/principles-configuration/principles/edit/PrinciplesConfigurationPrinciplesEditPage'
import { PrinciplesConfigurationPrinciplesPage } from 'src/screens/administration/configuration-management/principles-configuration/principles/PrinciplesConfigurationPrinciplesPage'
import { PrinciplesConfigurationIndexPage } from 'src/screens/administration/configuration-management/principles-configuration/PrinciplesConfigurationIndexPage'
import { AssessorManagementPage } from 'src/screens/administration/round-management/details/assessor-management/AssessorManagementPage'
import { CommitteeDecisionManagementPage } from 'src/screens/administration/round-management/details/round-information/committee-decision-management/CommitteeDecisionManagementPage'
import { RoundInformationEditPage } from 'src/screens/administration/round-management/details/round-information/edit/RoundInformationEditPage'
import { RoundInformationPage } from 'src/screens/administration/round-management/details/round-information/RoundInformationPage'
import { RoundManagementDetailsIndexPage } from 'src/screens/administration/round-management/details/RoundManagementDetailsIndexPage'
import { RoundManagementIndexPage } from 'src/screens/administration/round-management/RoundManagementIndexPage'
import { UserAdministrationPage } from 'src/screens/administration/user-administration/UserAdministrationPage'
import { PrinciplesConfigurationSubprinciplesPage } from 'src/screens/administration/configuration-management/principles-configuration/subprinciples/PrinciplesConfigurationSubprinciplesPage'
import { PrinciplesConfigurationSubprinciplesCreatePage } from 'src/screens/administration/configuration-management/principles-configuration/subprinciples/edit/PrinciplesConfigurationSubprinciplesCreatePage'
import { PrinciplesConfigurationSubprinciplesEditPage } from 'src/screens/administration/configuration-management/principles-configuration/subprinciples/edit/PrinciplesConfigurationSubprinciplesEditPage'
import { PrinciplesConfigurationPreviewPage } from 'src/screens/administration/configuration-management/principles-configuration/preview/PrinciplesConfigurationPreviewPage'
import { FeaturesConfigurationFeatureGroupsPage } from 'src/screens/administration/configuration-management/features-configuration/feature-groups/FeaturesConfigurationFeatureGroupsPage'
import { FeaturesConfigurationFeatureTypesPage } from 'src/screens/administration/configuration-management/features-configuration/feature-types/FeaturesConfigurationFeatureTypesPage'
import { FeaturesConfigurationPfKapPage } from 'src/screens/administration/configuration-management/features-configuration/pf-kap/FeaturesConfigurationPfKapPage'
import { FeaturesConfigurationPfPgvPage } from 'src/screens/administration/configuration-management/features-configuration/pf-pgv/FeaturesConfigurationPfPgvPage'
import { FeaturesConfigurationKapFactsheetPage } from 'src/screens/administration/configuration-management/features-configuration/kap-factsheet/FeaturesConfigurationKapFactsheetPage'
import { FeaturesConfigurationFeatureGroupsCreatePage } from 'src/screens/administration/configuration-management/features-configuration/feature-groups/edit/FeaturesConfigurationFeatureGroupsCreatePage'
import { FeaturesConfigurationFeatureGroupsEditPage } from 'src/screens/administration/configuration-management/features-configuration/feature-groups/edit/FeaturesConfigurationFeatureGroupsEditPage'
import { FeaturesConfigurationFeatureTypesCreatePage } from 'src/screens/administration/configuration-management/features-configuration/feature-types/edit/FeaturesConfigurationFeatureTypesCreatePage'
import { FeaturesConfigurationFeatureTypesEditPage } from 'src/screens/administration/configuration-management/features-configuration/feature-types/edit/FeaturesConfigurationFeatureTypesEditPage'
import { FeaturesConfigurationFeaturesPage } from 'src/screens/administration/configuration-management/features-configuration/features/FeaturesConfigurationFeaturesPage'
import { FeaturesConfigurationFeaturesCreatePage } from 'src/screens/administration/configuration-management/features-configuration/features/edit/FeaturesConfigurationFeaturesCreatePage'
import { FeaturesConfigurationFeaturesEditPage } from 'src/screens/administration/configuration-management/features-configuration/features/edit/FeaturesConfigurationFeaturesEditPage'

const UserAdministrationIndex = {
  path: 'administration/user-administration',
  Component: UserAdministrationPage,
  roles: ['PD-GFCH_PF-KAP_COORDINATOR', 'PD-GFCH_PF-PGV_COORDINATOR', 'PD-GFCH_KAP_COORDINATOR'],
} as const

const RoundManagementIndex = {
  path: 'administration/round-management',
  Component: RoundManagementIndexPage,
  roles: [
    'PD-GFCH_PF-KAP_COORDINATOR',
    'PD-GFCH_PF-PGV_COORDINATOR',
    'PD-GFCH_KAP_COORDINATOR',
    'PD-GFCH_FACTSHEET_COORDINATOR',
  ],
} as const

const ApplicationTypeManagementIndex = {
  path: 'administration/application-type-management',
  Component: ApplicationTypeManagementIndexPage,
  roles: ['PD-GFCH_PF-KAP_COORDINATOR', 'PD-GFCH_PF-PGV_COORDINATOR', 'PD-GFCH_KAP_COORDINATOR'],
} as const

const RoundManagementDetailsRoot = {
  path: 'administration/round-management/:roundId/details',
  Component: RoundManagementDetailsIndexPage,
  roles: [
    'PD-GFCH_PF-KAP_COORDINATOR',
    'PD-GFCH_PF-PGV_COORDINATOR',
    'PD-GFCH_KAP_COORDINATOR',
    'PD-GFCH_FACTSHEET_COORDINATOR',
  ],
} as const

const RoundInformation = {
  path: 'round-information',
  Component: RoundInformationPage,
  navigationKey: 'label.navigation.round.information',
  primary: true,
} as const

const RoundInformationEdit = {
  path: 'round-information/edit',
  Component: RoundInformationEditPage,
  hideNavigation: true,
} as const

const CommitteeDecisionManagement = {
  path: 'committee-decision-management',
  Component: CommitteeDecisionManagementPage,
  hideNavigation: true,
} as const

const AssessorManagement = {
  path: 'assessor-management',
  Component: AssessorManagementPage,
  navigationKey: 'label.navigation.assessor.management',
} as const

const FeaturesConfigurationIndex = {
  path: 'administration/features-config',
  Component: FeaturesConfigurationIndexPage,
  navigationKey: 'label.navigation.configuration.features',
  roles: ['PD-GFCH_PF-KAP_COORDINATOR', 'PD-GFCH_PF-PGV_COORDINATOR', 'PD-GFCH_KAP_COORDINATOR'],
} as const

const FeaturesConfigurationPfKap = {
  path: 'pf-kap',
  Component: FeaturesConfigurationPfKapPage,
  navigationKey: 'label.navigation.configuration.features.pf-kap',
  primary: true,
} as const

const FeaturesConfigurationPfPgv = {
  path: 'pf-pgv',
  Component: FeaturesConfigurationPfPgvPage,
  navigationKey: 'label.navigation.configuration.features.pf-pgv',
} as const

const FeaturesConfigurationKapFactsheet = {
  path: 'kap-factsheet',
  Component: FeaturesConfigurationKapFactsheetPage,
  navigationKey: 'label.navigation.configuration.features.kap-factsheet',
} as const

const FeaturesConfigurationFeatureTypes = {
  path: 'types',
  Component: FeaturesConfigurationFeatureTypesPage,
  navigationKey: 'label.configuration.features.feature.types',
  primary: true,
} as const

const FeaturesConfigurationFeatureTypesCreate = {
  path: 'types/new',
  Component: FeaturesConfigurationFeatureTypesCreatePage,
  hideNavigation: true,
} as const

const FeaturesConfigurationFeatureTypesEdit = {
  path: 'types/edit/:featureTypeId',
  Component: FeaturesConfigurationFeatureTypesEditPage,
  hideNavigation: true,
} as const

const FeaturesConfigurationFeatureGroups = {
  path: 'groups',
  Component: FeaturesConfigurationFeatureGroupsPage,
  navigationKey: 'label.configuration.features.feature.groups',
} as const

const FeaturesConfigurationFeatureGroupsCreate = {
  path: 'groups/new',
  Component: FeaturesConfigurationFeatureGroupsCreatePage,
  hideNavigation: true,
} as const

const FeaturesConfigurationFeatureGroupsEdit = {
  path: 'groups/edit/:featureGroupId',
  Component: FeaturesConfigurationFeatureGroupsEditPage,
  hideNavigation: true,
} as const

const FeaturesConfigurationFeatures = {
  path: 'features',
  Component: FeaturesConfigurationFeaturesPage,
  navigationKey: 'label.configuration.features',
} as const

const FeaturesConfigurationFeaturesCreate = {
  path: 'features/new',
  Component: FeaturesConfigurationFeaturesCreatePage,
  hideNavigation: true,
} as const

const FeaturesConfigurationFeaturesEdit = {
  path: 'features/edit/:featureConfigId',
  Component: FeaturesConfigurationFeaturesEditPage,
  hideNavigation: true,
} as const

const CriteriaConfigurationIndex = {
  path: 'administration/criteria-config',
  Component: CriteriaConfigurationIndexPage,
  navigationKey: 'label.navigation.configuration.criteria',
  roles: ['PD-GFCH_PF-KAP_COORDINATOR', 'PD-GFCH_PF-PGV_COORDINATOR', 'PD-GFCH_KAP_COORDINATOR'],
} as const

const CriteriaConfigurationPfKap = {
  path: 'pf-kap',
  Component: CriteriaConfigurationPfKapPage,
  navigationKey: 'label.navigation.configuration.criteria.pf_kap',
  primary: true,
} as const

const CriteriaConfigurationPfPgv = {
  path: 'pf-pgv',
  Component: CriteriaConfigurationPfPgvPage,
  navigationKey: 'label.navigation.configuration.criteria.pf_pgv',
} as const

const CriteriaConfigurationFactsheet = {
  path: 'factsheet',
  Component: CriteriaConfigurationFactsheetPage,
  navigationKey: 'label.navigation.configuration.criteria.factsheet',
} as const

const CriteriaConfigurationEvaluationCriteria = {
  path: 'evaluation-criteria',
  Component: CriteriaConfigurationEvaluationCriteriaPage,
  navigationKey: 'label.navigation.configuration.criteria.evaluation',
} as const

const CriteriaConfigurationEvaluationCriteriaCreate = {
  path: 'evaluation-criteria/new',
  Component: CriteriaConfigurationEvaluationCriteriaCreatePage,
  hideNavigation: true,
} as const

const CriteriaConfigurationEvaluationCriteriaEdit = {
  path: 'evaluation-criteria/edit/:criteriaId',
  Component: CriteriaConfigurationEvaluationCriteriaEditPage,
  hideNavigation: true,
} as const

const CriteriaConfigurationCriteriaGroups = {
  path: 'criteria-groups',
  Component: CriteriaConfigurationCriteriaGroupsPage,
  navigationKey: 'label.navigation.configuration.criteria.groups',
} as const

const CriteriaConfigurationCriteriaGroupsCreate = {
  path: 'criteria-groups/new',
  Component: CriteriaConfigurationCriteriaGroupsCreatePage,
  hideNavigation: true,
} as const

const CriteriaConfigurationCriteriaGroupsEdit = {
  path: 'criteria-groups/edit/:groupId',
  Component: CriteriaConfigurationCriteriaGroupsEditPage,
  hideNavigation: true,
} as const

const HelpInstructionsConfigurationIndex = {
  path: 'administration/help-and-instructions',
  Component: HelpInstructionsConfigurationIndexPage,
  navigationKey: 'label.navigation.configuration.help.instructions',
  roles: ['PD-GFCH_PF-KAP_COORDINATOR', 'PD-GFCH_PF-PGV_COORDINATOR', 'PD-GFCH_KAP_COORDINATOR'],
} as const

const HelpInstructionsConfigurationCreate = {
  path: 'administration/help-and-instructions/new',
  Component: HelpInstructionsConfigCreatePage,
  navigationKey: 'label.configuration.help.and.instructions.create',
  roles: ['PD-GFCH_PF-KAP_COORDINATOR', 'PD-GFCH_PF-PGV_COORDINATOR', 'PD-GFCH_KAP_COORDINATOR'],
} as const

const HelpInstructionsConfigurationEdit = {
  path: 'administration/help-and-instructions/edit/:helpInstructionId',
  Component: HelpInstructionsConfigEditPage,
  navigationKey: 'label.configuration.help.and.instructions.edit',
  roles: ['PD-GFCH_PF-KAP_COORDINATOR', 'PD-GFCH_PF-PGV_COORDINATOR', 'PD-GFCH_KAP_COORDINATOR'],
} as const

const MilestonesConfigurationIndex = {
  path: 'administration/milestones-config',
  Component: MilestonesConfigurationIndexPage,
  navigationKey: 'label.navigation.configuration.milestones',
  roles: ['PD-GFCH_PF-KAP_COORDINATOR', 'PD-GFCH_PF-PGV_COORDINATOR', 'PD-GFCH_KAP_COORDINATOR'],
} as const

const MilestoneConfigurationEdit = {
  path: 'administration/milestones-config/edit/:milestoneConfigId',
  Component: MilestoneConfigurationEditPage,
  roles: ['PD-GFCH_PF-KAP_COORDINATOR', 'PD-GFCH_PF-PGV_COORDINATOR', 'PD-GFCH_KAP_COORDINATOR'],
  hideNavigation: true,
} as const

const PrinciplesConfigurationIndex = {
  path: 'administration/principles-config',
  Component: PrinciplesConfigurationIndexPage,
  navigationKey: 'label.navigation.configuration.principles',
  roles: ['PD-GFCH_PF-KAP_COORDINATOR', 'PD-GFCH_PF-PGV_COORDINATOR', 'PD-GFCH_KAP_COORDINATOR'],
} as const

const PrinciplesConfigurationPreview = {
  path: 'preview',
  Component: PrinciplesConfigurationPreviewPage,
  navigationKey: 'label.navigation.configuration.principles.preview',
  primary: true,
} as const

const PrinciplesConfigurationPrinciples = {
  path: 'principles',
  Component: PrinciplesConfigurationPrinciplesPage,
  navigationKey: 'label.navigation.configuration.principles',
} as const

const PrinciplesConfigurationPrinciplesCreate = {
  path: 'principles/new',
  Component: PrinciplesConfigurationPrinciplesCreatePage,
  hideNavigation: true,
} as const

const PrinciplesConfigurationPrinciplesEdit = {
  path: 'principles/edit/:principleId',
  Component: PrinciplesConfigurationPrinciplesEditPage,
  hideNavigation: true,
} as const

const PrinciplesConfigurationSubprinciples = {
  path: 'subprinciples',
  Component: PrinciplesConfigurationSubprinciplesPage,
  navigationKey: 'label.navigation.configuration.subprinciples',
} as const

const PrinciplesConfigurationSubprinciplesCreate = {
  path: 'subprinciples/new',
  Component: PrinciplesConfigurationSubprinciplesCreatePage,
  hideNavigation: true,
} as const

const PrinciplesConfigurationSubprinciplesEdit = {
  path: 'subprinciples/edit/:subprincipleId',
  Component: PrinciplesConfigurationSubprinciplesEditPage,
  hideNavigation: true,
} as const

const CommitteesConfigurationIndex = {
  path: 'administration/committees',
  Component: CommitteeConfigurationIndexPage,
  navigationKey: 'label.navigation.configuration.committees',
  roles: ['PD-GFCH_PF-KAP_COORDINATOR', 'PD-GFCH_PF-PGV_COORDINATOR', 'PD-GFCH_KAP_COORDINATOR'],
} as const

const CommitteesConfigurationCreate = {
  path: 'administration/committees/:processType/new',
  Component: CommitteeConfigurationCreatePage,
  hideNavigation: true,
  roles: ['PD-GFCH_PF-KAP_COORDINATOR', 'PD-GFCH_PF-PGV_COORDINATOR', 'PD-GFCH_KAP_COORDINATOR'],
} as const

const CommitteesConfigurationEdit = {
  path: 'administration/committees/:processType/:committeeId',
  Component: CommitteeConfigurationEditPage,
  hideNavigation: true,
  roles: ['PD-GFCH_PF-KAP_COORDINATOR', 'PD-GFCH_PF-PGV_COORDINATOR', 'PD-GFCH_KAP_COORDINATOR'],
} as const

const CommitteesConfigurationPfKap = {
  path: 'pf-kap',
  Component: CommitteeConfigurationPfKapPage,
  navigationKey: 'label.navigation.configuration.criteria.pf_kap',
  primary: true,
} as const

const CommitteesConfigurationPfPgv = {
  path: 'pf-pgv',
  Component: CommitteeConfigurationPfPgvPage,
  navigationKey: 'label.navigation.configuration.criteria.pf_pgv',
} as const

const CommitteesConfigurationFactsheet = {
  path: 'factsheet',
  Component: CommitteeConfigurationFactsheetPage,
  navigationKey: 'label.navigation.configuration.criteria.factsheet',
} as const

export const AdministrationRoutes = {
  RoundManagementIndex: {
    ...RoundManagementIndex,
    params: (props: ExtractRouteParams<typeof RoundManagementIndex.path>) =>
      withParams(`/${RoundManagementIndex.path}`)(props),
  },
  RoundManagementDetailsRoot: {
    ...RoundManagementDetailsRoot,
    params: (props: ExtractRouteParams<typeof RoundManagementDetailsRoot.path>) =>
      withParams(`/${RoundManagementDetailsRoot.path}`)(props),
    nested: {
      RoundInformation: {
        ...RoundInformation,
        params: (
          props: ExtractRouteParams<ComposePaths<typeof RoundManagementDetailsRoot.path, typeof RoundInformation.path>>,
        ) => withParams(`/${RoundManagementDetailsRoot.path}/${RoundInformation.path}`)(props),
      },
      RoundInformationEdit: {
        ...RoundInformationEdit,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof RoundManagementDetailsRoot.path, typeof RoundInformationEdit.path>
          >,
        ) => withParams(`/${RoundManagementDetailsRoot.path}/${RoundInformationEdit.path}`)(props),
      },
      CommitteeDecisionManagement: {
        ...CommitteeDecisionManagement,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof RoundManagementDetailsRoot.path, typeof CommitteeDecisionManagement.path>
          >,
        ) => withParams(`/${RoundManagementDetailsRoot.path}/${CommitteeDecisionManagement.path}`)(props),
      },
      AssessorManagement: {
        ...AssessorManagement,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof RoundManagementDetailsRoot.path, typeof AssessorManagement.path>
          >,
        ) => withParams(`/${RoundManagementDetailsRoot.path}/${AssessorManagement.path}`)(props),
      },
    },
  },
  ApplicationTypeManagementIndex: {
    ...ApplicationTypeManagementIndex,
    params: (props: ExtractRouteParams<typeof ApplicationTypeManagementIndex.path>) =>
      withParams(`/${ApplicationTypeManagementIndex.path}`)(props),
  },
  UserAdministrationIndex: {
    ...UserAdministrationIndex,
    params: (props: ExtractRouteParams<typeof UserAdministrationIndex.path>) =>
      withParams(`/${UserAdministrationIndex.path}`)(props),
  },
  FeaturesConfigurationIndex: {
    ...FeaturesConfigurationIndex,
    params: (props: ExtractRouteParams<typeof FeaturesConfigurationIndex.path>) =>
      withParams(`/${FeaturesConfigurationIndex.path}`)(props),
    nested: {
      FeaturesConfigurationPfKap: {
        ...FeaturesConfigurationPfKap,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof FeaturesConfigurationIndex.path, typeof FeaturesConfigurationPfKap.path>
          >,
        ) => withParams(`/${FeaturesConfigurationIndex.path}/${FeaturesConfigurationPfKap.path}`)(props),
      },
      FeaturesConfigurationPfPgv: {
        ...FeaturesConfigurationPfPgv,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof FeaturesConfigurationIndex.path, typeof FeaturesConfigurationPfPgv.path>
          >,
        ) => withParams(`/${FeaturesConfigurationIndex.path}/${FeaturesConfigurationPfPgv.path}`)(props),
      },
      FeaturesConfigurationKapFactsheet: {
        ...FeaturesConfigurationKapFactsheet,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof FeaturesConfigurationIndex.path, typeof FeaturesConfigurationKapFactsheet.path>
          >,
        ) => withParams(`/${FeaturesConfigurationIndex.path}/${FeaturesConfigurationKapFactsheet.path}`)(props),
      },
      FeaturesConfigurationFeatureTypes: {
        ...FeaturesConfigurationFeatureTypes,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof FeaturesConfigurationIndex.path, typeof FeaturesConfigurationFeatureTypes.path>
          >,
        ) => withParams(`/${FeaturesConfigurationIndex.path}/${FeaturesConfigurationFeatureTypes.path}`)(props),
      },
      FeaturesConfigurationFeatureTypesCreate: {
        ...FeaturesConfigurationFeatureTypesCreate,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof FeaturesConfigurationIndex.path, typeof FeaturesConfigurationFeatureTypesCreate.path>
          >,
        ) => withParams(`/${FeaturesConfigurationIndex.path}/${FeaturesConfigurationFeatureTypesCreate.path}`)(props),
      },
      FeaturesConfigurationFeatureTypesEdit: {
        ...FeaturesConfigurationFeatureTypesEdit,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof FeaturesConfigurationIndex.path, typeof FeaturesConfigurationFeatureTypesEdit.path>
          >,
        ) => withParams(`/${FeaturesConfigurationIndex.path}/${FeaturesConfigurationFeatureTypesEdit.path}`)(props),
      },
      FeaturesConfigurationFeatureGroups: {
        ...FeaturesConfigurationFeatureGroups,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof FeaturesConfigurationIndex.path, typeof FeaturesConfigurationFeatureGroups.path>
          >,
        ) => withParams(`/${FeaturesConfigurationIndex.path}/${FeaturesConfigurationFeatureGroups.path}`)(props),
      },
      FeaturesConfigurationFeatureGroupsCreate: {
        ...FeaturesConfigurationFeatureGroupsCreate,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof FeaturesConfigurationIndex.path, typeof FeaturesConfigurationFeatureGroupsCreate.path>
          >,
        ) => withParams(`/${FeaturesConfigurationIndex.path}/${FeaturesConfigurationFeatureGroupsCreate.path}`)(props),
      },
      FeaturesConfigurationFeatureGroupsEdit: {
        ...FeaturesConfigurationFeatureGroupsEdit,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof FeaturesConfigurationIndex.path, typeof FeaturesConfigurationFeatureGroupsEdit.path>
          >,
        ) => withParams(`/${FeaturesConfigurationIndex.path}/${FeaturesConfigurationFeatureGroupsEdit.path}`)(props),
      },
      FeaturesConfigurationFeatures: {
        ...FeaturesConfigurationFeatures,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof FeaturesConfigurationIndex.path, typeof FeaturesConfigurationFeatures.path>
          >,
        ) => withParams(`/${FeaturesConfigurationIndex.path}/${FeaturesConfigurationFeatures.path}`)(props),
      },
      FeaturesConfigurationFeaturesCreate: {
        ...FeaturesConfigurationFeaturesCreate,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof FeaturesConfigurationIndex.path, typeof FeaturesConfigurationFeaturesCreate.path>
          >,
        ) => withParams(`/${FeaturesConfigurationIndex.path}/${FeaturesConfigurationFeaturesCreate.path}`)(props),
      },
      FeaturesConfigurationFeaturesEdit: {
        ...FeaturesConfigurationFeaturesEdit,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof FeaturesConfigurationIndex.path, typeof FeaturesConfigurationFeaturesEdit.path>
          >,
        ) => withParams(`/${FeaturesConfigurationIndex.path}/${FeaturesConfigurationFeaturesEdit.path}`)(props),
      },
    },
  },
  CriteriaConfigurationIndex: {
    ...CriteriaConfigurationIndex,
    params: (props: ExtractRouteParams<typeof CriteriaConfigurationIndex.path>) =>
      withParams(`/${CriteriaConfigurationIndex.path}`)(props),
    nested: {
      CriteriaConfigurationPfKap: {
        ...CriteriaConfigurationPfKap,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof CriteriaConfigurationIndex.path, typeof CriteriaConfigurationPfKap.path>
          >,
        ) => withParams(`/${CriteriaConfigurationIndex.path}/${CriteriaConfigurationPfKap.path}`)(props),
      },
      CriteriaConfigurationPfPgv: {
        ...CriteriaConfigurationPfPgv,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof CriteriaConfigurationIndex.path, typeof CriteriaConfigurationPfPgv.path>
          >,
        ) => withParams(`/${CriteriaConfigurationIndex.path}/${CriteriaConfigurationPfPgv.path}`)(props),
      },
      CriteriaConfigurationFactsheet: {
        ...CriteriaConfigurationFactsheet,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof CriteriaConfigurationIndex.path, typeof CriteriaConfigurationFactsheet.path>
          >,
        ) => withParams(`/${CriteriaConfigurationIndex.path}/${CriteriaConfigurationFactsheet.path}`)(props),
      },
      CriteriaConfigurationEvaluationCriteria: {
        ...CriteriaConfigurationEvaluationCriteria,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof CriteriaConfigurationIndex.path, typeof CriteriaConfigurationEvaluationCriteria.path>
          >,
        ) => withParams(`/${CriteriaConfigurationIndex.path}/${CriteriaConfigurationEvaluationCriteria.path}`)(props),
      },
      CriteriaConfigurationEvaluationCriteriaCreate: {
        ...CriteriaConfigurationEvaluationCriteriaCreate,
        params: (
          props: ExtractRouteParams<
            ComposePaths<
              typeof CriteriaConfigurationIndex.path,
              typeof CriteriaConfigurationEvaluationCriteriaCreate.path
            >
          >,
        ) =>
          withParams(`/${CriteriaConfigurationIndex.path}/${CriteriaConfigurationEvaluationCriteriaCreate.path}`)(
            props,
          ),
      },
      CriteriaConfigurationEvaluationCriteriaEdit: {
        ...CriteriaConfigurationEvaluationCriteriaEdit,
        params: (
          props: ExtractRouteParams<
            ComposePaths<
              typeof CriteriaConfigurationIndex.path,
              typeof CriteriaConfigurationEvaluationCriteriaEdit.path
            >
          >,
        ) =>
          withParams(`/${CriteriaConfigurationIndex.path}/${CriteriaConfigurationEvaluationCriteriaEdit.path}`)(props),
      },
      CriteriaConfigurationCriteriaGroups: {
        ...CriteriaConfigurationCriteriaGroups,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof CriteriaConfigurationIndex.path, typeof CriteriaConfigurationCriteriaGroups.path>
          >,
        ) => withParams(`/${CriteriaConfigurationIndex.path}/${CriteriaConfigurationCriteriaGroups.path}`)(props),
      },
      CriteriaConfigurationCriteriaGroupsCreate: {
        ...CriteriaConfigurationCriteriaGroupsCreate,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof CriteriaConfigurationIndex.path, typeof CriteriaConfigurationCriteriaGroupsCreate.path>
          >,
        ) => withParams(`/${CriteriaConfigurationIndex.path}/${CriteriaConfigurationCriteriaGroupsCreate.path}`)(props),
      },
      CriteriaConfigurationCriteriaGroupsEdit: {
        ...CriteriaConfigurationCriteriaGroupsEdit,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof CriteriaConfigurationIndex.path, typeof CriteriaConfigurationCriteriaGroupsEdit.path>
          >,
        ) => withParams(`/${CriteriaConfigurationIndex.path}/${CriteriaConfigurationCriteriaGroupsEdit.path}`)(props),
      },
    },
  },
  HelpInstructionsConfigurationIndex: {
    ...HelpInstructionsConfigurationIndex,
    params: (props: ExtractRouteParams<typeof HelpInstructionsConfigurationIndex.path>) =>
      withParams(`/${HelpInstructionsConfigurationIndex.path}`)(props),
  },
  HelpInstructionsConfigurationCreate: {
    ...HelpInstructionsConfigurationCreate,
    params: (props: ExtractRouteParams<typeof HelpInstructionsConfigurationCreate.path>) =>
      withParams(`/${HelpInstructionsConfigurationCreate.path}`)(props),
  },
  HelpInstructionsConfigurationEdit: {
    ...HelpInstructionsConfigurationEdit,
    params: (props: ExtractRouteParams<typeof HelpInstructionsConfigurationEdit.path>) =>
      withParams(`/${HelpInstructionsConfigurationEdit.path}`)(props),
  },
  MilestonesConfigurationIndex: {
    ...MilestonesConfigurationIndex,
    params: (props: ExtractRouteParams<typeof MilestonesConfigurationIndex.path>) =>
      withParams(`/${MilestonesConfigurationIndex.path}`)(props),
  },
  MilestonesConfigurationEdit: {
    ...MilestoneConfigurationEdit,
    params: (props: ExtractRouteParams<typeof MilestoneConfigurationEdit.path>) =>
      withParams(`/${MilestoneConfigurationEdit.path}`)(props),
  },
  PrinciplesConfigurationIndex: {
    ...PrinciplesConfigurationIndex,
    params: (props: ExtractRouteParams<typeof PrinciplesConfigurationIndex.path>) =>
      withParams(`/${PrinciplesConfigurationIndex.path}`)(props),
    nested: {
      PrinciplesConfigurationPreview: {
        ...PrinciplesConfigurationPreview,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof PrinciplesConfigurationIndex.path, typeof PrinciplesConfigurationPreview.path>
          >,
        ) => withParams(`/${PrinciplesConfigurationIndex.path}/${PrinciplesConfigurationPreview.path}`)(props),
      },
      PrinciplesConfigurationPrinciples: {
        ...PrinciplesConfigurationPrinciples,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof PrinciplesConfigurationIndex.path, typeof PrinciplesConfigurationPrinciples.path>
          >,
        ) => withParams(`/${PrinciplesConfigurationIndex.path}/${PrinciplesConfigurationPrinciples.path}`)(props),
      },
      PrinciplesConfigurationPrinciplesCreate: {
        ...PrinciplesConfigurationPrinciplesCreate,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof PrinciplesConfigurationIndex.path, typeof PrinciplesConfigurationPrinciplesCreate.path>
          >,
        ) => withParams(`/${PrinciplesConfigurationIndex.path}/${PrinciplesConfigurationPrinciplesCreate.path}`)(props),
      },
      PrinciplesConfigurationPrinciplesEdit: {
        ...PrinciplesConfigurationPrinciplesEdit,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof PrinciplesConfigurationIndex.path, typeof PrinciplesConfigurationPrinciplesEdit.path>
          >,
        ) => withParams(`/${PrinciplesConfigurationIndex.path}/${PrinciplesConfigurationPrinciplesEdit.path}`)(props),
      },
      PrinciplesConfigurationSubprinciples: {
        ...PrinciplesConfigurationSubprinciples,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof PrinciplesConfigurationIndex.path, typeof PrinciplesConfigurationSubprinciples.path>
          >,
        ) => withParams(`/${PrinciplesConfigurationIndex.path}/${PrinciplesConfigurationSubprinciples.path}`)(props),
      },
      PrinciplesConfigurationSubprinciplesCreate: {
        ...PrinciplesConfigurationSubprinciplesCreate,
        params: (
          props: ExtractRouteParams<
            ComposePaths<
              typeof PrinciplesConfigurationIndex.path,
              typeof PrinciplesConfigurationSubprinciplesCreate.path
            >
          >,
        ) =>
          withParams(`/${PrinciplesConfigurationIndex.path}/${PrinciplesConfigurationSubprinciplesCreate.path}`)(props),
      },
      PrinciplesConfigurationSubprinciplesEdit: {
        ...PrinciplesConfigurationSubprinciplesEdit,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof PrinciplesConfigurationIndex.path, typeof PrinciplesConfigurationSubprinciplesEdit.path>
          >,
        ) =>
          withParams(`/${PrinciplesConfigurationIndex.path}/${PrinciplesConfigurationSubprinciplesEdit.path}`)(props),
      },
    },
  },
  CommitteesConfigurationIndex: {
    ...CommitteesConfigurationIndex,
    params: (props: ExtractRouteParams<typeof CommitteesConfigurationIndex.path>) =>
      withParams(`/${CommitteesConfigurationIndex.path}`)(props),
    nested: {
      CommitteesConfigurationPfKap: {
        ...CommitteesConfigurationPfKap,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof CommitteesConfigurationIndex.path, typeof CommitteesConfigurationPfKap.path>
          >,
        ) => withParams(`/${CommitteesConfigurationIndex.path}/${CommitteesConfigurationPfKap.path}`)(props),
      },
      CommitteesConfigurationPfPgv: {
        ...CommitteesConfigurationPfPgv,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof CommitteesConfigurationIndex.path, typeof CommitteesConfigurationPfPgv.path>
          >,
        ) => withParams(`/${CommitteesConfigurationIndex.path}/${CommitteesConfigurationPfPgv.path}`)(props),
      },
      CommitteesConfigurationFactsheet: {
        ...CommitteesConfigurationFactsheet,
        params: (
          props: ExtractRouteParams<
            ComposePaths<typeof CommitteesConfigurationIndex.path, typeof CommitteesConfigurationFactsheet.path>
          >,
        ) => withParams(`/${CommitteesConfigurationIndex.path}/${CommitteesConfigurationFactsheet.path}`)(props),
      },
    },
  },
  CommitteesConfigurationIndexCreate: {
    ...CommitteesConfigurationCreate,
    params: (props: ExtractRouteParams<typeof CommitteesConfigurationCreate.path>) =>
      withParams(`/${CommitteesConfigurationCreate.path}`)(props),
  },
  CommitteesConfigurationIndexEdit: {
    ...CommitteesConfigurationEdit,
    params: (props: ExtractRouteParams<typeof CommitteesConfigurationEdit.path>) =>
      withParams(`/${CommitteesConfigurationEdit.path}`)(props),
  },
}
